import Messages from "../../../js/util/Messages.js";
import {initHeaderScrollShadow} from "../../../js/util/HeaderUtils.js";

export default class BatchPageHeaderHtml {
    #root;

    init(headerEl) {
        this.#root = headerEl;
        this.rightSection().insertAdjacentHTML(
            'afterbegin',
            `<section class="header-chips">
                        <span
                            id="header-chip-readonly"
                            class="header-chip header-chip--error visually-hidden"
                            title="${Messages.BATCH.CHANGES_WILL_NOT_BE_SAVED_IN_READ_ONLY_MODE}"
                            >READONLY</span>
                  </section>
                  <section class="header-buttons-section"></section>`);
        if (this.middleSection())
            this.middleSection().remove()
        initHeaderScrollShadow(headerEl)
    }
    showReadOnlyChip() {
        this.#root.querySelector('#header-chip-readonly').classList.remove('visually-hidden');
    }

    leftSection() {
        return this.#root.querySelector('.page-header__section--align-start');
    }

    middleSection() {
        return this.#root.querySelector('.page-header__section--align-mid');
    }

    rightSection() {
        return this.#root.querySelector('.page-header__section--align-end');
    }

    /** @returns {HTMLElement} */
    getUserHeaderElement() {
        return this.#root.querySelector('.page-header__section--user');
    }

    /** @returns {HTMLElement} */
    getBreadcrumbsElement() {
        return this.#root.querySelector('.page-header__breadcrumbs-section');
    }
}